/** Shared geometry for the nreport roof/report mark. Keep exports in sync with scripts/generate-brand-assets.mjs. */
export const NREPORT_MARK_PATH = "M4 28V11L16 3l12 8v17h-6V14.2L16 10l-6 4.2V28H4Zm9-11h6v4h-6v-4Zm0 7h6v4h-6v-4Z";
export const BRAND_INK = "#143D35";
export const BRAND_PAPER = "#F7F8F2";
export const BRAND_MINT = "#C9E8C5";
